import React from "react";
import { connect } from "react-redux";
import { selectDayRange, selectWeekCount } from "../redux/selectors";

class ChildEventView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            width: props.event.end - props.event.start
        };
    }

    checkIsVisible = () => {
        if (this.props.event.start > this.props.weekCount * 7 - 1) {
            return false;
        }

        if (this.props.event.end <= 0) {
            return false;
        }
        return true;
    };

    render() {
        if (this.checkIsVisible() === false) {
            return null;
        }

        const start = this.props.event.start < 1 ? 0 : this.props.event.start;
        const end =
            this.props.event.end > this.props.weekCount * 7
                ? this.props.weekCount * 7
                : this.props.event.end;
        const position = {
            gridColumnStart: start + 1,
            gridColumnEnd: end + 1,
            gridRowStart: this.props.event.row,
            gridRowEnd: this.props.event.row,
            background: this.props.event.color,
            filter: this.props.selected ? "opacity(80%)" : ""
        };

        return (
            <div className={`EventView`} style={{ ...position }}>
                <div className="EventViewTitle">
                    <span>{this.props.event.name}</span>
                </div>
            </div>
        );
    }
}

export default connect(
    store => {
        return {
            dayRange: selectDayRange(store),
            weekCount: selectWeekCount(store)
        };
    },
    {}
)(ChildEventView);
